export default __webpack_public_path__ + "static/media/supportPlaceholder.4859fc02.svg";